// extracted by mini-css-extract-plugin
export default {"nav_section":"navigation_nav_section__q3m4m","footer_copy_right":"navigation_footer_copy_right__Hu3qg","social_media_wrapper":"navigation_social_media_wrapper__tIAOA"};